import { useTranslation } from "react-i18next";

export function Loading({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label ?? t("common.loading")}
      className="page-loading-skeleton w-full py-5"
    >
      <span className="sr-only">{label ?? t("common.loading")}</span>
      <div className="page-loading-skeleton__header" aria-hidden="true">
        <span className="skeleton-block h-7 w-48" />
        <span className="skeleton-block mt-2 h-4 w-72 max-w-full" />
      </div>
      <div className="page-loading-skeleton__filters" aria-hidden="true">
        <span className="skeleton-block h-11 flex-1" />
        <span className="skeleton-block h-11 flex-1" />
        <span className="skeleton-block h-11 w-28" />
      </div>
      <div className="page-loading-skeleton__table" aria-hidden="true">
        <div className="page-loading-skeleton__table-head">
          <span className="skeleton-block h-3 w-20" />
          <span className="skeleton-block h-3 w-24" />
          <span className="skeleton-block h-3 w-16" />
          <span className="skeleton-block h-3 w-20" />
        </div>
        {Array.from({ length: 6 }, (_, index) => (
          <div key={index} className="page-loading-skeleton__row">
            <span className="skeleton-block h-4 w-4/5" />
            <span className="skeleton-block h-4 w-3/4" />
            <span className="skeleton-block h-4 w-2/3" />
            <span className="skeleton-block h-8 w-16 justify-self-end" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function NotFound({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      className="grid place-items-center py-16 text-sm text-ink-3"
    >
      {label ?? t("common.noData")}
    </div>
  );
}
